type RefListener = () => void;

/**
 * Registry of named DOM refs with a listener API for waiting until a ref exists.
 */
export default class RefManager {
  refs: Record<string, Record<string, Element | null>>;
  listeners: RefListener[];

  constructor() {
    this.refs = {};
    this.listeners = [];
  }

  setRef(id: string, namespace: string, ref: Element | null) {
    if (!(namespace in this.refs)) {
      this.refs[namespace] = {};
    }

    this.refs[namespace][id] = ref;
    this.callListeners();
  }

  addListener(listener: RefListener) {
    this.listeners.push(listener);
  }

  removeListener(listener: RefListener) {
    const pos = this.listeners.indexOf(listener);

    if (pos !== -1) {
      this.listeners.splice(pos, 1);
    }
  }

  getRefs() {
    return this.refs;
  }

  callListeners() {
    this.listeners.forEach((listener) => listener());
  }

  waitForRef(id: string, namespace: string): Promise<Element | null> {
    return new Promise((resolve) => {
      let ref: Element | null = this.refs[namespace]?.[id] ?? null;

      if (ref != null) {
        resolve(ref);
        return;
      }

      const listener = () => {
        ref = this.refs[namespace]?.[id] ?? null;

        if (ref != null) {
          this.removeListener(listener);
          resolve(ref);
        }
      };

      this.addListener(listener);
    });
  }
}
